import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('VendorCentralAccountDTO')
export class VendorCentralAccountDTO {
  @JsonProperty('id', Number, false) id: number = undefined;
  @JsonProperty('name', String, true) name: string = undefined;
  @JsonProperty('vendors', [Number], false) vendors: number[] = undefined;
  @JsonProperty('botEnabled', Boolean, true) botEnabled: boolean = undefined;
}
